var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout-report-with-banner',{attrs:{"showProgress":false,"showFooter":false,"showLoginButton":_vm.showLoginButton},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('booking-detail',{attrs:{"bookingId":_vm.bookingId}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }